const numberToMoreOrLessString = (number, t) => {
  // If number is positive, then return more, else return less
  return number > 0 ? t('general.more') : t('general.less')
}

export {
  numberToMoreOrLessString
}
